import { render, staticRenderFns } from "./FailedSlate.vue?vue&type=template&id=635eb292"
import script from "./FailedSlate.vue?vue&type=script&lang=js"
export * from "./FailedSlate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports